// src/Reducers/CustomerReducer.js
import * as Types from '../Constants/AllConstants';

export const GetAllCustomersReducer = (
  state = { customers: [], pages: 0, page: 0 },
  action
) => {
  switch (action.type) {
    case Types.CUSTOMER_LIST_REQUEST:
      return { ...state, loading: true };
    case Types.CUSTOMER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        customers: action.payload.content,
        pages: action.payload.totalPages,
        page: action.payload.number,
      };
    case Types.CUSTOMER_LIST_FAIL:
      return { loading: false, error: action.payload };
    case Types.CUSTOMER_LIST_RESET:
      return { customers: [] };
    default:
      return state;
  }
};

export const GetCustomerDetailsReducer = (state = { customer: {} }, action) => {
  switch (action.type) {
    case Types.CUSTOMER_DETAILS_REQUEST:
      return { loading: true };
    case Types.CUSTOMER_DETAILS_SUCCESS:
      return { loading: false, customer: action.payload };
    case Types.CUSTOMER_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const CreateCustomerReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.CUSTOMER_CREATE_REQUEST:
      return { loading: true };
    case Types.CUSTOMER_CREATE_SUCCESS:
      return { loading: false, success: true, customer: action.payload };
    case Types.CUSTOMER_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.CUSTOMER_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

export const UpdateCustomerReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.CUSTOMER_UPDATE_REQUEST:
      return { loading: true };
    case Types.CUSTOMER_UPDATE_SUCCESS:
      return { loading: false, success: true, customer: action.payload };
    case Types.CUSTOMER_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.CUSTOMER_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};
